module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        Import wielu adresów e-mail\n    ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "navigate_before"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")])], 1), _vm._v(" "), _c('ui-alert', {
    attrs: {
      "dismissible": false,
      "hide-icon": ""
    }
  }, [_vm._v("\n        Wklej adresy e-mail w pole poniżej, jeden adres w jednej lini. Adresy zostaną sprawdzone i zostaną dodane tylko te które jeszcze nie istnieją. Jeśli adres e-mail istnieje jego grupy zostaną zmienione na wybrane ponizej.\n    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Wklej adresy e-mail",
      "name": "emails",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wklej adresy e-mail",
      "multi-line": "",
      "rows": 8
    },
    model: {
      value: (_vm.item.emails),
      callback: function($$v) {
        _vm.item.emails = $$v
      },
      expression: "item.emails"
    }
  }), _vm._v(" "), _c('i-select-multiple', {
    attrs: {
      "name": "groups",
      "label": "Grupy do których będą dodane te adresy",
      "keys": _vm.keysForSelect,
      "options": _vm.groups,
      "search-placeholder": "Szukaj",
      "show-search": true,
      "placeholder": "wybierz grupy do których będą dodane te adresy",
      "required": ""
    },
    model: {
      value: (_vm.item.groups),
      callback: function($$v) {
        _vm.item.groups = $$v
      },
      expression: "item.groups"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Importuj wklejone adresy")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07b8e651","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/Import.vue
// module id = 224
// module chunks = 0